
const ApproveAndSendEmail = theme => ({
    modalBody: {
        display: "flex",
        flex: 1,
        flexDirection: "column",
        paddingLeft: 21,
        paddingRight: 21,
        paddingTop: 20,
        overflowY: "auto",
        maxHeight: 620
    },
    doseSpotModalBody: {
        display: "flex",
        flex: 1,
        flexDirection: "column",
        overflow: "hidden",
        paddingTop: 20,
    },
    headerSection: {
        display: "flex",
        paddingLeft: 22,
        paddingRight: 10,
        paddingBottom: 10,
        flexDirection: "column",
        borderBottom: "1px solid #979797"
    },
    blueText: {
        color: "#002a50",
        fontFamily: "Proxima Nova",
        fontSize: 23,
        fontWeight: "bold",
        letterSpacing: 0,
        lineHeight: "27px"
    },
    orangeText: {
        color: "#ff6e21",
        fontFamily: "Proxima Nova",
        fontSize: 23,
        fontWeight: "bold",
        letterSpacing: 0,
        lineHeight: "27px",
        paddingLeft: "15%"
    },
    doseSpotIframeStyle: {
        display: "flex",
        flex: 1,
        paddingLeft: 12,
        flexDirection: "column",
        overflow: "hidden"
    },
    modalBodyWrapper: {
        display: "flex",
        flex: 1,
        position: "relative",
        overflow: "hidden",
        flexDirection: "column",
    },

    titleTextEmail: {
        width: "140px",
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: 14,
        marginTop: 7,
        fontWeight: "bold",
        letterSpacing: 0,
        lineHeight: "17px"
    },
    menuItemWidth: {
        minWidth: 60,
        maxWidth: 60
    },
    productSelectStyle: {
        padding: 0,
        paddingLeft: 10
    },
    menuItemList: {
        "& li": {
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "inline-block",
            width: "100%"
        }
    },
    menuItemSelected: {
        backgroundColor: "#f3fdfd !important"
    },
    menuItemRoot: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "14px",
        letterSpacing: 0,
        lineHeight: "17px"
    },
    productInput: {
        width: 73,
        height: 30,
        "& > div": {
            height: 30,
            border: "1px solid #979797",
            borderRadius: 3
        },
        "& fieldset": {
            display: "none"
        },
        "& div": {
            color: "#242424",
            fontFamily: "Proxima Nova",
            fontSize: "14px",
            letterSpacing: 0,
            backgroundColor: "white",
            lineHeight: "17px"
        },
        "& div:focus": {
            backgroundColor: "white !important",
        }
    },
    productInputError: {
        width: 73,
        height: 30,
        "& > div": {
            height: 30,
            border: "1px solid red",
            borderRadius: 3
        },
        "& fieldset": {
            display: "none"
        },
        "& div": {
            color: "#242424",
            fontFamily: "Proxima Nova",
            fontSize: "14px",
            letterSpacing: 0,
            backgroundColor: "white",
            lineHeight: "17px"
        },
        "& div:focus": {
            backgroundColor: "white !important",
        }
    },
    templateInput: {
        flexGrow: 1,
        height: 30,
        "& > div": {
            height: 30,
            border: "1px solid #979797",
            borderRadius: 3
        },
        "& fieldset": {
            display: "none"
        },
        "& div": {
            color: "#242424",
            fontFamily: "Proxima Nova",
            fontSize: "14px",
            letterSpacing: 0,
            backgroundColor: "white",
            lineHeight: "17px"
        },
        "& div:focus": {
            backgroundColor: "white !important",
        }
    },
    templateInputError: {
        flexGrow: 1,
        height: 30,
        "& > div": {
            height: 30,
            border: "1px solid red",
            borderRadius: 3
        },
        "& fieldset": {
            display: "none"
        },
        "& div": {
            color: "#242424",
            fontFamily: "Proxima Nova",
            fontSize: "14px",
            letterSpacing: 0,
            backgroundColor: "white",
            lineHeight: "17px"
        },
        "& div:focus": {
            backgroundColor: "white !important",
        }
    },
    textInput: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "14px",
        letterSpacing: 0,
        padding: "0px 10px",
        backgroundColor: "white",
        lineHeight: "17px",
        flexGrow: 1,
        height: 30,
        border: "1px solid #979797",
        boxSizing: "border-box",
        outline: "none",
    },

    textInputError: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "14px",
        letterSpacing: 0,
        padding: "0px 10px",
        backgroundColor: "white",
        lineHeight: "17px",
        flexGrow: 1,
        height: 30,
        border: "1px solid red",
        boxSizing: "border-box",
        outline: "none",
    },
    subjectInput: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "14px",
        letterSpacing: 0,
        padding: "0px 10px",
        backgroundColor: "white",
        lineHeight: "17px",
        flexGrow: 1,
        height: 30,
        paddingTop: 5,
        resize: "none",
        border: "1px solid #979797",
        boxSizing: "border-box",
        outline: "none",
        whiteSpace: "pre",
        "overflow-wrap": "normal",
        "overflow-x": "scroll"
    },

    subjectInputError: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "14px",
        letterSpacing: 0,
        padding: "0px 10px",
        paddingTop: 5,
        backgroundColor: "white",
        lineHeight: "17px",
        flexGrow: 1,
        height: 30,
        resize: "none",
        border: "1px solid red",
        boxSizing: "border-box",
        outline: "none",
        whiteSpace: "pre",
        "overflow-wrap": "normal",
        "overflow-x": "scroll"
    },
    textArea: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "14px",
        letterSpacing: 0,
        backgroundColor: "white",
        lineHeight: "17px",
        flexGrow: 1,
        height: 250,
        border: "1px solid #979797",
        resize: "none",
        boxSizing: "border-box",
        outline: "none",
        padding: 10
    },
    textAreaError: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "14px",
        letterSpacing: 0,
        backgroundColor: "white",
        lineHeight: "17px",
        flexGrow: 1,
        height: 250,
        border: "1px solid red",
        resize: "none",
        boxSizing: "border-box",
        outline: "none",
        padding: 10
    },
    flagTextArea: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "14px",
        letterSpacing: 0,
        backgroundColor: "white",
        lineHeight: "17px",
        height: 50,
        maxHeight: 50,
        display: "flex",
        flex: 1,
        border: "1px solid #979797",
        resize: "none",
        boxSizing: "border-box",
        outline: "none",
        padding: 10,
        marginBottom: 17
    },
    flagTextAreaError: {
        borderColor: "red !important",
    },
    emailTemplateMarginTop: {
        marginTop: 13
    },
    textAreaReason: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "14px",
        letterSpacing: 0,
        backgroundColor: "white",
        lineHeight: "17px",
        flexGrow: 1,
        height: 100,
        border: "1px solid #979797",
        resize: "none",
        boxSizing: "border-box",
        outline: "none",
        padding: 10
    },
    textAreaReasonError: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "14px",
        letterSpacing: 0,
        backgroundColor: "white",
        lineHeight: "17px",
        flexGrow: 1,
        height: 100,
        border: "1px solid red",
        resize: "none",
        boxSizing: "border-box",
        outline: "none",
        padding: 10
    },
    buttonStyle: {
        boxShadow: 'none',
        width: 197,
        height: 30,
        textTransform: 'none',
        fontSize: 16,
        lineHeight: "20px",
        padding: 0,
        marginRight: 20,
        fontWeight: "bold",
        backgroundColor: '#00ad50',
        fontFamily: "Proxima Nova",
        '&:hover': {
            backgroundColor: '#00ad50',
            boxShadow: 'none',
        },
        '&:active': {
            backgroundColor: '#00ad50',
            boxShadow: 'none',
        },
        '&:focus': {
            backgroundColor: '#00ad50',
            boxShadow: 'none',
        },
        '&:disabled': {
            color: 'white',
            boxShadow: 'none',
        },
    },
    doseSpotButtonStyle: {
        boxShadow: 'none',
        width: 197,
        height: 30,
        textTransform: 'none',
        fontSize: 16,
        lineHeight: "20px",
        padding: 0,
        marginRight: 20,
        fontWeight: "bold",
        backgroundColor: '#00ad50',
        fontFamily: "Proxima Nova",
        '&:hover': {
            backgroundColor: '#00ad50',
            boxShadow: 'none',
        },
        '&:active': {
            backgroundColor: '#00ad50',
            boxShadow: 'none',
        },
        '&:focus': {
            backgroundColor: '#00ad50',
            boxShadow: 'none',
        },
        '&:disabled': {
            color: 'white',
            boxShadow: 'none',
        },
    },
    cancelButtonStyle: {
        boxShadow: 'none',
        width: 197,
        height: 30,
        textTransform: 'none',
        fontSize: 16,
        lineHeight: "20px",
        padding: 0,
        border: "1px solid #4d4d4d",
        color: "#242424",
        fontWeight: "bold",
        backgroundColor: 'white',
        fontFamily: "Proxima Nova",
        '&:hover': {
            backgroundColor: 'white',
            boxShadow: 'none',
        },
        '&:active': {
            backgroundColor: 'white',
            boxShadow: 'none',
        },
        '&:focus': {
            backgroundColor: 'white',
            boxShadow: 'none',
        },
    },
    modalActionWrapper: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "flex-end",
        marginRight: 21,
        marginTop: 15,
        marginBottom: 15
    },
    doseSpotModalActionWrapper: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "flex-end",
        marginRight: 21,
        marginTop: 15,
        marginBottom: 15
    },



    wrapper: {
        display: "flex",
        flex: 1,
        flexDirection: "column",
        padding: '10px 18px',
        border: "1px solid #979797",
        backgroundColor: "#F5F5F5",
        marginBottom: 7
    },
    AlternateRxWrapper: {
        display: "flex",
        height: 143,
        maxHeight: 143,
        minHeight: 143,
        flex: 1,
        flexDirection: "column",
        paddingTop: 20,
        paddingLeft: 17,
        paddingRight: 17,
        border: "1px solid #979797",
        backgroundColor: "#F5F5F5",
        marginBottom: 7
    },
    contentWrapper: {
        display: "flex",
        flexWrap: 'wrap',
        marginBottom: 12
    },
    contentWrapperNoAlign: {
        display: "flex",
        flexShrink: 0,
        marginBottom: 40,
    },
    contentEmailWrapper: {
        display: "flex",
        flexShrink: 0,
        alignItems: "center",
        marginBottom: 10
    },
    sigContentWrapper: {
        display: "flex",
        marginBottom: 22
    },
    noteContentWrapper: {
        display: "flex",
    },
    lastContentWrapper: {
        display: "flex",
        marginBottom: 6
    },
    qtyContentWrapper: {
        display: "flex",
        flexWrap: 'wrap',
        alignItems: "center"
    },
    qtyItemWrapper: {
        display: "flex",
        alignItems: "center",
        marginBottom: 12,
        marginRight: 24
    },
    flex: {
        display: "flex",
    },
    titleText: {
        width: "107px",
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: 14,
        fontWeight: "bold",
        letterSpacing: 0,
        lineHeight: "17px",
        marginBottom: 4,

        '&.no-margin': {
            marginBottom: 0
        }
    },
    mainTitleText: {
        width: "140px",
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: 14,
        fontWeight: "bold",
        letterSpacing: 0,
        lineHeight: "17px"
    },
    pharmacyText: {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "block !important",
        flexGrow: 1,
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "14px",
        letterSpacing: 0,
        lineHeight: "17px"
    },
    contentText: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "14px",
        letterSpacing: 0,
        lineHeight: "17px",
        display: "flex",
        alignItems: "center"
    },
    totalPillsContentText: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "14px",
        letterSpacing: 0,
        lineHeight: "17px",
        display: "flex",
        alignItems: "center"
    },
    expContent: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "14px",
        letterSpacing: 0,
        lineHeight: "17px",
        display: "flex",
        alignItems: "center"
    },
    dailySupplyText: {
        width: "107px",
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: 14,
        fontWeight: "bold",
        letterSpacing: 0,
        lineHeight: "17px"
    },
    totalPillsText: {
        width: "97px",
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: 14,
        fontWeight: "bold",
        letterSpacing: 0,
        lineHeight: "17px"
    },
    refillText: {
        width: "65px",
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: 14,
        fontWeight: "bold",
        letterSpacing: 0,
        lineHeight: "17px"
    },
    expText: {
        width: "40px",
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: 14,
        fontWeight: "bold",
        letterSpacing: 0,
        lineHeight: "17px"
    },
    subAllowedText: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: 14,
        fontWeight: "bold",
        letterSpacing: 0,
        lineHeight: "17px"
    },
    dailySupplyWrapper: {
        display: "flex",
        alignItems: "center"
    },
    daysSupplyText: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "14px",
        letterSpacing: 0,
        padding: "0px 10px",
        backgroundColor: "white",
        lineHeight: "17px",
        width: 50,
        height: 30,
        border: "1px solid #979797",
        boxSizing: "border-box",
        outline: "none",
    },
    sigTextInput: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "14px",
        letterSpacing: 0,
        padding: "0px 10px",
        backgroundColor: "white",
        lineHeight: "17px",
        flexGrow: 1,
        height: 30,
        border: "1px solid #979797",
        boxSizing: "border-box",
        outline: "none",
    },
    pinTextInput: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "14px",
        letterSpacing: 0,
        padding: "0px 10px",
        backgroundColor: "white",
        lineHeight: "17px",
        width: 80,
        textAlign: "center",
        height: 30,
        border: "1px solid #979797",
        boxSizing: "border-box",
        outline: "none",
        marginRight: 20
    },
    NoteTextArea: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "14px",
        letterSpacing: 0,
        padding: "7px 10px",
        backgroundColor: "white",
        lineHeight: "17px",
        flexGrow: 1,
        height: 50,
        resize: "none",
        border: "1px solid #979797",
        boxSizing: "border-box",
        outline: "none",
    },
    quantityProperites: {
        display: "flex",
        width: "887px",
        justifyContent: "space-between"
    },
    pharmacyTextSpan: {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "block !important",
        width: "100%",
    },
    errorTextField: {
        borderColor: "red !important"
    },
    pinWrapper: {
        display: "flex",
        alignItems: "center"
    },
    pinStyle: {
        width: "86px",
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "14px",
        fontWeight: "bold",
        letterSpacing: 0,
        lineHeight: "17px",
    },
    flagText: {
        color: "#E12929",
        fontFamily: "Proxima Nova",
        fontSize: "14px",
        letterSpacing: 0,
        lineHeight: "17px",
        whiteSpace: "pre-wrap",
        marginBottom: 5
    },
    flagWrapper: {
        display: "flex",
        flexShrink: 0,
        flexDirection: "column"
    },
    approvalPinError: {
        color: "#E12929",
        fontFamily: "Proxima Nova",
        fontSize: 14,
        lineHeight: "17px",
        marginRight: 20
    },
    noTextMargin: {
        marginBottom: "0px !important"
    },
    disabledSelect: {
        "& div": {
            backgroundColor: "#cccccc !important"
        }
    }
})

export default ApproveAndSendEmail;